export const loadWechatSDK = () => {
  if (!window.wx) {
    let script = document.createElement('script');
    script.src = 'https://uatlegolas.airasia.com/jweixin-1.3.2.js';
    script.type = 'text/javascript';
    script.defer = true;
    document.body.appendChild(script);
  }
};

export const isFromWechat = channel => {
  return channel === 'WECHAT';
};
